<template>
  <el-dialog
    title="支付记录"
    :visible.sync="dialogVisible"
    width="1300px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <BaseTable
      :tableData="payTableData"
      :columns="payColumns"
      :row-class-name="getRowClassName"
    >
      <template #paymentTypeStr="{ row }">
        <span v-if="row.paymentTypeStr === '直接支付'">
          {{ row.paymentTypeStr }}
        </span>
        <el-button
          v-else
          type="text"
          size="small"
          @click="seeMergeRecords(row)"
          >{{ row.paymentTypeStr }}</el-button
        >
      </template>

      <template #attachmentIds="{ row }">
        <span v-if="row.attachmentIds">
          <el-button
            type="text"
            size="small"
            @click="seeFileList(row.attachmentIds)"
            >{{ row.attachmentIds.split(",").length }}</el-button
          >
        </span>
      </template>
    </BaseTable>
  </el-dialog>
</template>

<script>
import BaseTable from "@/components/BaseTable";

export default {
  name: "PaymentRecord",
  components: {
    BaseTable,
  },
  data() {
    return {
      dialogVisible: false,
      payTableData: [],
      payColumns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          showOverflowTooltip: true,
          width: 135,
        },
        {
          prop: "userIdStr",
          label: "结算师傅名称",
          width: 135,
        },
        {
          prop: "companyName",
          label: "公司名称",
        },
        {
          prop: "paymentTypeStr",
          label: "支付类型",
          slot: "paymentTypeStr",
        },
        {
          prop: "allocatedAmount",
          label: "收到金额（本单）",
          width: 135,
        },
        {
          prop: "paymentAmount",
          label: "支付金额",
        },
        {
          prop: "paymentMethod",
          label: "付款方式",
        },
        {
          prop: "attachmentIds",
          label: "付款凭证",
          slot: "attachmentIds",
        },
        {
          prop: "createdByStr",
          label: "操作人",
        },
        {
          prop: "updateTime",
          label: "操作时间",
          width: 135,
        },
        {
          prop: "statusStr",
          label: "状态",
        },
        {
          prop: "remarks",
          label: "备注",
          showOverflowTooltip: true,
        },
      ],
    };
  },
  methods: {
    // 打开弹窗
    open(settlementOrderId) {
      this.dialogVisible = true;
      this.getPayData(settlementOrderId);
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.payTableData = [];
    },

    // 获取支付记录数据
    getPayData(id) {
      this.axios({
        url: "/v1/web/settlement/payment-record/list",
        method: "post",
        data: {
          queryInfoParams: {
            settlementOrderId: id,
          },
          extraInfo: {
            queryAll: true,
          },
          size: 999,
          page: 1,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.payTableData = res.data.data.list;
          this.payTableData = this.payTableData.filter((item) => {
            // 过滤掉没有支付金额的记录
            return item.allocatedAmount > 0;
          });
        }
      });
    },

    // 查看合并支付记录
    seeMergeRecords(row) {
      this.$emit("see-merge-records", row);
    },

    // 查看文件列表
    seeFileList(ids) {
      const filtList = ids.split(",");
      this.$emit("see-file-list", filtList);
    },

    // 获取行样式类名
    getRowClassName({ row }) {
      // 如果状态为已删除，返回红色样式类
      if (row.statusStr === "已删除" || row.status === 0) {
        return "deleted-row";
      }
      return "";
    },
  },
};
</script>

<style scoped>
/* 样式已移至全局文件 src/assets/css/table-row-styles.css */
/* 这里可以添加组件特定的样式 */
</style>
